import React from 'react';
import { Map } from '../../../../../Shared';

function AdminMap(props) {
  const { positionChoose, setMapDataPosition, radius,setRadius, setOption, isDisplayTrafficStatus } = props;
  return (
    <Map
      positionChoose={positionChoose}
      setMapDataPosition={setMapDataPosition}
      radius={radius}
      setRadius={setRadius}
      setOption={setOption}
      isDisplayTrafficStatus={isDisplayTrafficStatus}
    />
  );
}
export default AdminMap;
